import { createRoot, type Root } from "react-dom/client";
import { MainApp } from "./MainApp";

declare global {
  interface Window {
    __kuiiRoot__?: Root;
  }
}

function start() {
  const container = document.getElementById("root")!;
  const root = window.__kuiiRoot__ ?? createRoot(container);

  window.__kuiiRoot__ = root;
  root.render(<MainApp />);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}
